/* eslint-disable react/prop-types */
import React, { useState, Suspense, useEffect } from "react";
import { isBrowser, isIOS, isMobile, mobileModel } from "react-device-detect";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { PageLoader } from "../../../components";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

// Images
import MonetiseBackgroundImage from "../../../assets/images/login/loginBackground.svg";
import FlozyXEducate from "../../../assets/images/login/FlozyxTOT.svg";

// Import Child Container
import { useSelector } from "react-redux";
import history from "../../../config/history";

interface AuthLayoutProps {
  children: React.ReactNode;
  user?: any;
  access?: boolean;
}

/**
 * AuthLayout - Converted to TypeScript with shadcn/ui
 * Maintains exact same design and behavior as original
 */
const AuthLayout: React.FC<AuthLayoutProps> = (props) => {
  const safeAreaTopHeight = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--sat");
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(true);

  const { profile } = useSelector((s: any) => s.profile);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const delay = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const handleImageLoad = async () => {
    await delay(100);
    setIsLoading(false);
  };

  const notchClass =
    isIOS && isMobile && !isBrowser && mobileModel === "iPhone"
      ? "notchContainer"
      : "";

  return (
    <div className="h-screen w-full flex bg-card p-[16px]">
      {!isMobile && <div className="w-full h-full flex-shrink-0 basis-1/2">
        <img
          src={MonetiseBackgroundImage}
          alt="banner Image"
          className="w-full h-full object-cover rounded-xl"
        />
      </div>}
      <div className="w-full h-full bg-background rounded-xl flex items-center justify-center overflow-y-auto">
        {props.children}
      </div>
    </div>
  );
};

export default AuthLayout;
